export default class CreatePartyViewmodel {
    public companyName: string = '';
    public contactName: string = '';
    public jobTitle: string = '';
    public email: string = '';
    public office: string = '';
}